import uiEvents from 'events/ui';
import hideCustomMinimizedButton from 'app/dom_mutators/hideCustomMinimizedButton';

export default function hideDefaultAndCustomWidget(dispatch) {
  hideCustomMinimizedButton();
  dispatch(uiEvents.hideWidget());
}
